//natives
import React, { Component } from 'react';
import Cookies from 'universal-cookie';
import MUIDataTable from "mui-datatables";
import { Helmet } from 'react-helmet';
// import TagManager from 'react-gtm-module';

import TextLabels from '../../../../../util/Table/.mixins/TextLabels';

import {Typography, CircularProgress} from "@material-ui/core";

//components
import Alerta from '../../../../../util/snackbars/.mixins/';
import Filter from '../../../../../util/filter/.mixins/Filter';
import Columns from '../childrens/columns/.mixins';
import Lista from '../childrens/lista/.mixins';

//constrollers
import Config from '../../../../../../controllers/config';
import Log from '../../../../../../controllers/log';

export default class Logs extends Component {

    constructor(props) {
        super(props);

        this.child = React.createRef();
        this.inputRef = React.createRef();

        this.state = {
            itensTable: [["Carregando dados..."]],
            title: "Logs",
            columns: Columns,
            isLoading: true,
            isError: false,
            error: null,
            print: false,
            filter: false,
            download: false,
            filters: {
                datas: false,
                flagsPag: false,
            },
            fornecedor: null,
            page: 0,
            count: 1,
            rowsPerPage: 15,
            serverSide: true,
            rowsPerPageOptions: [],
            sortOrder: {},
            onTableChange: null,
            size: "small",
            selectableRows: "none",
            responsive: 'scrollFullHeight',
            textLabels: TextLabels,
            filterText: ''
        };
        
        //binds
        this.setState = this.setState.bind(this);
        this.loadData = this.loadData.bind(this);
        
    }

    componentDidMount() {
        // TagManager.dataLayer({
        //     dataLayer: {
        //       event: 'event',
        //       eventCategory: 'tokstok:fornecedores:logs',
        //       eventAction: 'componentDidMount',
        //       eventLabel: 'componente-logs',
        //     }
        // });

        //auditoria
        const cookies = new Cookies();
        const token = cookies.get('User-Token');
        Log.info(token,"Efetuado carregamento da tela lista de grupos!");

        const { isLoading } = this.state;
        this.setState({ 
            onTableChange: (action, tableState) => {
                if (action == 'changePage')
                    this.changePage(tableState.page, tableState.sortOrder);
                if (action == 'search')
                    this.getData(0,tableState.searchText);
            },
            title: (<Typography variant="h6">
                Logs
                {isLoading &&
                    <CircularProgress
                        size={24} 
                        style={{marginLeft: 15, position: 'relative', top: 4}} 
                    />
                }
            </Typography>)
        });
        this.getData(0,'');
    }

    getData = async (page,busca) => {
        await this.setState({ 
            isLoading: true,
            itensTable: [["Carregando dados..."]],
            filterText: busca?busca.replace("'",""):""
        });
        this.xhrRequest(page, {}).then(res => {
            this.setState({ 
                itensTable: res.data, 
                isLoading: false, 
                count: res.total
            });
        });
    }

    xhrRequest = (page, sortOrder = {}) => {
        
        return new Promise(async (resolve, reject) => {

            let {data,total} = await this.requisicao();
            let sortField = sortOrder.name;
            let sortDir = sortOrder.direction;

            if (sortField) {
                data = data.sort((a, b) => {
                    if (a[sortField] < b[sortField]) {
                        return  1 * (sortDir === 'asc' ? -1 : 1);
                    } else if (a[sortField] > b[sortField]) {
                        return -1 * (sortDir === 'asc' ? -1 : 1);
                    } else {
                        return 0;
                    }
                });
            }

            setTimeout(() => {
                resolve({
                    data, total, page
                });
            }, 500);

        });

    }

    changePage = async (page, sortOrder) => {
        await this.setState({
            isLoading: true,
            itensTable: [["Carregando dados..."]],
            page: page,
        });
        const res = await this.xhrRequest(page, sortOrder);
        this.setState({
            isLoading: false,
            page: res.page,
            sortOrder,
            itensTable: res.data,
            count: res.total,
        });
    };

    async loadData() {
        this.setState({
            isLoading: true,
            itensTable: [["Carregando dados..."]],
            page: 1
        });
      try {
        const { data, total } = await this.requisicao();
        this.setState({
            isLoading: false,
            itensTable: data,
            count: total
        });
        return { data, total };
      } catch (error) {
        console.error(error);
      }
    }

    async requisicao() {
        return new Promise(async (resolve, reject) => {
            const cookies = new Cookies();
            const token = cookies.get('User-Token');

            try {
                const filters = {
                    idFornecedor: this.state.fornecedor!=null?this.state.fornecedor:0,
                    linhaInicial: this.state.page*this.state.rowsPerPage,
                    qtdRegistro: this.state.rowsPerPage,
                    filters: (this.state.filterText==null)?'':this.state.filterText
                };
                const r_logs = await Log.get(token,filters);
                const j_r_logs = JSON.parse(r_logs.body);
                const arrayItens = j_r_logs.itens.map(e => {
                    return {...e,DS_TIPO: (e.DS_TIPO.includes('I')?'Auditória':'Erro')};
                });
                if (r_logs.res.statusCode == 200) {

                    // TagManager.dataLayer({
                    //     dataLayer: {
                    //       event: 'event',
                    //       eventCategory: 'tokstok:fornecedores:logs',
                    //       eventAction: 'callback',
                    //       eventLabel: `sucesso:lista-logs`,
                    //     }
                    // });

                    resolve({
                        data: arrayItens,
                        total: j_r_logs.total.value
                    });
                } else {
                    if (
                        j_r_logs.status == false && 
                        j_r_logs.message && 
                        j_r_logs.message.includes("Token inválido!")
                    ) {
                        this.child.current.retorno('Autentificação inválida!','error');
                        setTimeout(() => {
                            window.location.reload();
                        }, 1000);
                    } else {
                        throw new Error("Campos necessários, não foram retornados pelo servidor!");
                    }
                }

                //auditoria
                var str = "Efetuada requisição para recuperação de dados de logs! "
                +"Response:( Method: "+r_logs.res.request.method
                +", StatusCode: "+r_logs.res.statusCode
                +", Body: (limited 100chars)"+r_logs.body.substr(0,100)
                +" )";
                Log.info(token,str);
            } catch (error) {
                this.child.current.retorno('Erro ao carregar dados!','error');
                var errorString = "Erro ao carregar dados!";
                if (Config.DEBUG === "TRUE")
                    errorString = error.message;
                this.setState({
                    isError: true,
                    isLoading: false,
                    error: errorString
                });

                // TagManager.dataLayer({
                //     dataLayer: {
                //       event: 'event',
                //       eventCategory: 'tokstok:fornecedores:logs',
                //       eventAction: 'callback',
                //       eventLabel: `erro:${error.message}`,
                //     }
                // });

                //auditoria
                var str = "Erro na recuperação de dados de grupos! "
                +"Error:( Message: "+error.message+", Stack: "+error.stack+" )";
                Log.error(token,str);
                reject(error);
            }
        });
    }

    render() {

        const { itensTable, isLoading } = this.state;

        return(
            <div>
                <Helmet>
                    <title>{`${process.env.REACT_APP_TITLE} - Logs`}</title>
                </Helmet>
                <div className="container">
                    <Filter {...this}/>
                    <br/>
                    <MUIDataTable 
                        title={
                            <Typography variant="h6">
                                Logs
                                {isLoading && 
                                    <CircularProgress 
                                        size={24} 
                                        style={{
                                            marginLeft: 15, 
                                            position: 'relative', 
                                            top: 4
                                        }} 
                                    />
                                }
                            </Typography>
                        }
                        data={itensTable} 
                        columns={this.state.columns} 
                        options={this.state} 
                    />
                </div>
                
                <Alerta ref={this.child}/>
            </div>
        );
    }

}